<app-alert *ngIf="helperService.showAlert" [type]=helperService.typeAlert [Message]="helperService.messageAlert | translate">
</app-alert>
<section class="background-login" style="background-image: url(../../../assets/backgroundLogin.png);">
    <div class="sec-login">
        <div class="logo-login-hr">
            <img src="../../../assets/InchcapeLogo.svg" alt="InchcapeLogoBlanco">
        </div>

        <div class="content-login">
            <h1 class="title-HR">DIGITAL SERVICE BOOKING</h1>
            <a [href]="ssoSignOnUrl" class="loginLink"><button class="btn-login">Login</button></a>
        </div>
    </div>
</section>


